// extracted by mini-css-extract-plugin
module.exports = {"TextareaField__label":"ox_a"};